import Toggler from "../../../scripts/classes/Toggler";

var IconCardBig = function(options) {

    this.options = {
        $el: true,
    };

    $.extend(true, this.options, options);

};

IconCardBig.prototype.init = function() {
    this.toggler = new Toggler( this.options.$el );
    this.toggler.init();

};

export default IconCardBig;